module.exports = __webpack_public_path__ + "img/2U.1.93deb496.jpg";